<body>
  <div class="main">
    <div class="grid-overlay">
      <div class="nav">
        <a href="/">{{ 'login.nav.back' | translate }}</a>
      </div>

      <div class="logoblock">
        <img
          (click)="goHome()"
          src="../../assets/images/BRAND.png"
          alt="Logo Billcentrix"
          />
          <!-- título dinámico -->
          @if (!modoSeleccionPortal) {
            <h2>{{ 'login.title' | translate }}</h2>
          }
          @if (modoSeleccionPortal) {
            <h2>{{ 'login.selectCompany' | translate }}</h2>
          }
        </div>

        <!-- 🔑 Formulario de login (solo cuando NO es admin) -->
        @if (!modoSeleccionPortal) {
          <div class="login-modal-content">
            <div class="modal-login">
              <div class="background-white">
                <h1>{{ 'login.title' | translate }}</h1>
                <form class="user" [formGroup]="signinForm" (ngSubmit)="signin()">
                  <div>
                    <input
                      type="email"
                      [placeholder]="'login.form.emailPlaceholder' | translate"
                      [formControl]="signinForm.controls['username']"
                      id="exampleInputEmail"
                      />
                      @if (
                        signinForm.controls['username'].hasError('required') &&
                        signinForm.controls['username'].touched
                        ) {
                        <small
                          class="form-error-msg"
                          >{{ 'login.form.emailRequired' | translate }}</small
                          >
                      }
                      @if (
                        signinForm.controls['username'].hasError('email') &&
                        signinForm.controls['username'].touched
                        ) {
                        <small
                          class="form-error-msg"
                          >{{ 'login.form.emailInvalid' | translate }}</small
                          >
                        }
                      </div>
                      <!-- VISTA DE PASSKEY (cuando tiene passkey y está en modo passkey) -->
                      @if (hasPasskey && activeLoginMethod === 'passkey') {
                        <div class="passkey-login-section">
                          <div class="passkey-header">
                            <mat-icon class="passkey-icon">fingerprint</mat-icon>
                            <h3>{{ 'login.passkey.loginWith' | translate:{method: biometricMethodName} }}</h3>
                            <p>{{ 'login.passkey.verifyIdentity' | translate }}</p>
                          </div>
                          <button
                            type="button"
                            class="btn-passkey-login"
                            (click)="loginWithPasskey()"
                            [disabled]="isLoadingPasskey">
                            <mat-icon>{{ isLoadingPasskey ? 'hourglass_empty' : 'fingerprint' }}</mat-icon>
                            @if (!isLoadingPasskey) {
                              <span>{{ 'login.passkey.useMethod' | translate:{method: biometricMethodName} }}</span>
                            }
                            @if (isLoadingPasskey) {
                              <span>{{ 'login.passkey.verifying' | translate }}</span>
                            }
                          </button>
                          <!-- Error de passkey -->
                          @if (passkeyError) {
                            <div class="passkey-error">
                              <mat-icon>error</mat-icon>
                              <span>{{ passkeyError }}</span>
                            </div>
                          }
                          <!-- Opción para volver a login tradicional -->
                          <div class="switch-method-section">
                            <button type="button" class="btn-switch-method" (click)="switchToStandardLogin()">
                              <mat-icon>arrow_back</mat-icon>
                              <span>{{ 'login.passkey.usePassword' | translate }}</span>
                            </button>
                          </div>
                          <!-- Separador -->
                          <div class="separator">
                            <span>{{ 'login.separator' | translate }}</span>
                          </div>
                          <!-- Botón de Google Sign-In -->
                          <div class="google-signin-wrapper">
                            <asl-google-signin-button
                              type="standard"
                              size="large"
                              text="continue_with">
                            </asl-google-signin-button>
                          </div>
                        </div>
                      }
                      <!-- VISTA TRADICIONAL (cuando NO tiene passkey o está en modo standard) -->
                      @if (!hasPasskey || activeLoginMethod === 'standard') {
                        <div>
                          <div class="password-container">
                            <input
                              [type]="passwordFieldType"
                              [placeholder]="'login.form.passwordPlaceholder' | translate"
                              [formControl]="signinForm.controls['password']"
                              id="exampleInputPassword"
                              />
                              <button
                                type="button"
                                (click)="togglePasswordVisibility()"
                                class="hideview"
                                >
                                <mat-icon style="font-size: 20px">{{
                                  passwordFieldType === 'password'
                                  ? 'visibility'
                                  : 'visibility_off'
                                }}</mat-icon>
                              </button>
                              @if (
                                signinForm.controls['password'].hasError('required') &&
                                signinForm.controls['password'].touched
                                ) {
                                <small
                                  class="form-error-msg"
                                  >{{ 'login.form.passwordRequired' | translate }}</small
                                  >
                              }
                            </div>
                            <p>{{ 'login.form.forgotPassword' | translate }}</p>
                            <a href="/reset">{{ 'login.form.forgotPasswordLink' | translate }}</a>
                            <div class="options">
                              <div class="checkbox">
                                <input type="checkbox" id="checkbox-remember" class="cookies" />
                                <label for="checkbox-remember" [innerHTML]="'login.form.rememberMe' | translate"></label>
                              </div>
                              <button [disabled]="signinForm.invalid" type="submit">
                                {{ 'login.form.submit' | translate }}
                              </button>
                            </div>
                            <!-- Separador -->
                            <div class="separator">
                              <span>{{ 'login.separator' | translate }}</span>
                            </div>
                            <!-- Botón de Passkey (si el navegador lo soporta) -->
                            @if (webAuthnSupported) {
                              <button
                                type="button"
                                class="btn-passkey-alternative"
                                (click)="checkAndLoginWithPasskey()"
                                [disabled]="isCheckingPasskey || isLoadingPasskey">
                                <mat-icon>{{ isCheckingPasskey || isLoadingPasskey ? 'hourglass_empty' : 'fingerprint' }}</mat-icon>
                                @if (!isCheckingPasskey && !isLoadingPasskey) {
                                  <span>{{ 'login.passkey.continueWith' | translate }}</span>
                                }
                                @if (isCheckingPasskey) {
                                  <span>{{ 'login.passkey.verifying' | translate }}</span>
                                }
                                @if (isLoadingPasskey) {
                                  <span>{{ 'login.passkey.authenticating' | translate }}</span>
                                }
                              </button>
                            }
                            <!-- Error de passkey -->
                            @if (passkeyError) {
                              <small class="form-error-msg passkey-error-inline">
                                <mat-icon>error</mat-icon>
                                {{ passkeyError }}
                              </small>
                            }
                            <!-- Botón de Google Sign-In usando el componente de la librería -->
                            <div class="google-signin-wrapper">
                              <asl-google-signin-button
                                type="standard"
                                size="large"
                                text="continue_with">
                              </asl-google-signin-button>
                            </div>
                          </div>
                        }
                      </form>
                    </div>
                    <div class="transparent-background">
                      <p>{{ 'login.newAccount.question' | translate }}</p>
                      <button (click)="goRegistry()">{{ 'login.newAccount.register' | translate }}</button>
                    </div>
                  </div>
                </div>
              }

              <!-- 🟢 Selección de portales (cuando es admin) -->
              @if (modoSeleccionPortal) {
                <app-select-portal
                  [portals]="portals"
                ></app-select-portal>
              }

              <img src="../../assets/images/grafica-2.svg" alt="graff" />
            </div>
          </div>

        </body>
